


import icons from "../../../../../Data/icons";
import classes from "./addCompanies.module.css";


const EditCategories = ({

  name ,setActive ,active , setName
  
}) => {

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleActiveChange =(e)=>{
    const isChecked =e.target.checked
   setActive(isChecked ?1 :0)
  }
   
  const Abc = icons.abc

  return (
    <div className={classes.formCard}>
      <h5 className={classes.headTitle}>معلومات الفئة</h5>

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">اسم الفئة</label>
          <div className={classes.iconInput}>
            <Abc />
          </div>
          <input
            type="text"
            placeholder="ادخل اسم الفئة"
           value={name}
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
      
        <div className={classes.formCol}>
          <label htmlFor="active"  className={active ? `${classes.active}` : `${classes.disActive}`}>   {active===1 ?" نشط":"غير نشط"} </label>
         
         <label class="switch">
          <input type="checkbox" onChange={handleActiveChange} checked={active}/>
            <span class="slider round"></span>
        </label>  
           </div>

     
      </div>
    </div>
  );
};

export default EditCategories;
